import type { dashboard as enDashboard } from "../en/dashboard";

export const dashboard: typeof enDashboard = {
  trialBanner: {
    prefix: "Il tuo periodo di prova gratuito termina tra",
    dayUnit: "giorno",
    daysUnit: "giorni",
    pickPlanLink: "Scegli un piano",
    suffix: "per mantenere attivi i tuoi preventivi.",
  },
  atAGlance: {
    heading: "Riepilogo",
    openQuotes: "Preventivi aperti",
    pendingPoImports: "Ordini d'acquisto in attesa",
    plan: "Piano",
    trialEnds: "La prova termina il {{date}}",
  },
  nextBestAction: {
    heading: "Prossima azione consigliata",
    emptyBefore:
      "I suggerimenti IA compaiono qui mentre lavori. Quote Desk calcola il prezzo delle righe di preventivo e prepara controfferte basate sullo storico ordini di ogni azienda — apri un preventivo in bozza e prova “Suggerisci prezzi con l'IA”. Insegna all'IA le tue regole di prezzo e il tuo tono di voce una volta sola in",
    emptyAfter: ".",
    priceSuggestion: "Suggerimento di prezzo",
    review: "Rivedi",
    unknownCompany: "(azienda sconosciuta)",
  },
  followUp: {
    heading: "Da ricontattare",
    empty:
      "Al momento non c'è nulla da sollecitare — ottimo lavoro nel restare aggiornato. I preventivi rimasti non visualizzati per più di 3 giorni (o visualizzati senza una decisione per più di 5) compaiono qui, così nessuna trattativa si blocca in silenzio.",
    unviewedSent: "Inviato da oltre 3 giorni, l'acquirente non l'ha ancora aperto ({{count}})",
    viewedNotActedOn: "Visualizzato da oltre 5 giorni, nessuna accettazione/rifiuto ({{count}})",
    daysIdle: "{{days}}gg inattivo",
    daysSinceView: "{{days}}gg dalla visualizzazione",
  },
  performance: {
    heading: "Prestazioni",
    empty:
      "Il tasso di conversione, il tempo medio di accettazione e le tue aziende migliori compaiono qui dopo il terzo preventivo — sei sulla buona strada!",
    totalQuotes: "Preventivi totali",
    conversion: "Conversione (accettati ÷ conclusi)",
    avgTimeToAccept: "Tempo medio di accettazione",
    totalAcceptedValue: "Valore totale accettato",
    topCompanies: "Aziende principali per numero di preventivi",
    quoteCountOne: "{{count}} preventivo",
    quoteCountOther: "{{count}} preventivi",
    accepted: "{{count}} accettati",
    won: "{{amount}} conclusi",
  },
  recentQuotes: {
    heading: "Preventivi recenti",
    emptyHeading: "Nessun preventivo ancora",
    emptyAction: "Crea il tuo primo preventivo",
    emptyBody:
      "Crea un preventivo B2B con prezzi personalizzati — il tuo acquirente lo accetta da un link sicuro e diventa automaticamente un ordine bozza Shopify.",
  },
  getStarted: {
    heading: "Per iniziare",
    createQuote: "Crea un preventivo",
    viewCompanies: "Visualizza aziende",
    uploadPo: "Carica un ordine d'acquisto",
    setUpAi: "Configura la tua IA",
    plansAndBilling: "Piani e fatturazione",
  },
};
